import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, GitMerge } from "lucide-react";
import api from "@/lib/api";

export default function DuplicatesModal({ onClose, onMerged }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/crm/contacts/duplicates").then((r) => setGroups(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const mergeGroup = async (group) => {
    const [primary, ...duplicates] = group.contacts;
    try {
      await api.post("/admin/crm/contacts/merge", { primary_id: primary.id, duplicate_ids: duplicates.map((d) => d.id) });
      toast.success(`Merged ${duplicates.length} duplicate(s) into ${primary.name}`);
      load();
      onMerged?.();
    } catch {
      toast.error("Could not merge contacts");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={onClose} data-testid="crm-duplicates-modal">
      <div className="glass-panel rounded-2xl p-5 max-w-lg w-full max-h-[80vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <p className="text-sm font-semibold text-white">Duplicate Contacts</p>
          <button onClick={onClose} data-testid="crm-close-duplicates-btn"><X className="w-4 h-4 text-slate-400 hover:text-white" /></button>
        </div>
        {loading && <p className="text-xs text-slate-500">Scanning for duplicates…</p>}
        {!loading && groups.length === 0 && <p className="text-xs text-slate-500" data-testid="crm-no-duplicates">No duplicates found — your contact list is clean.</p>}
        <div className="space-y-4">
          {groups.map((g, i) => (
            <div key={i} className="bg-white/5 rounded-xl p-3" data-testid={`crm-duplicate-group-${i}`}>
              <p className="text-xs text-slate-400 mb-2">Shared phone: {g.phone}</p>
              {g.contacts.map((c, idx) => (
                <p key={c.id} className="text-xs text-slate-200 py-0.5">{idx === 0 ? "Keep → " : "Merge → "}{c.name} ({c.email})</p>
              ))}
              <button onClick={() => mergeGroup(g)} data-testid={`crm-merge-group-btn-${i}`}
                className="flex items-center gap-1.5 text-xs font-semibold bg-primary hover:bg-primary/90 text-white px-3 py-1.5 rounded-lg mt-2">
                <GitMerge className="w-3.5 h-3.5" /> Merge into "{g.contacts[0].name}"
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
